module.exports = __webpack_public_path__ + "media/images/pack-02-47c85593a06a811d45e54a79bfa90db6.jpg";